import { HUMANOID_JOINTS } from '../entities/humanoid';
import { WOLF_JOINTS } from '../entities/wolf';
import type { AnimProfile } from './controller';
import { FLINCH, HUMANOID_CLIPS, idlePose, locomotionPose, stunPose } from './humanoid-clips';
import { WOLF_CLIPS, WOLF_FLINCH, wolfGait, wolfIdle } from './wolf-clips';

export function humanoidProfile(
  variant: 'sword' | 'staff' | 'spear' | 'basket' | 'none' = 'sword',
): AnimProfile {
  const armed = variant === 'sword';
  return {
    joints: HUMANOID_JOINTS,
    idle: (t) => idlePose(t, variant),
    locomotion: (phase, run) => locomotionPose(phase, run, armed),
    clips: HUMANOID_CLIPS,
    flinch: FLINCH,
    stun: stunPose,
    stride: [1.35, 2.5, 3.6],
    speeds: [1.6, 5.2, 7.8],
  };
}

export const WOLF_PROFILE: AnimProfile = {
  joints: WOLF_JOINTS,
  idle: wolfIdle,
  locomotion: (phase, run) => wolfGait(phase, Math.min(1, run)),
  clips: WOLF_CLIPS,
  flinch: WOLF_FLINCH,
  stride: [1.4, 2.6, 3.0],
  speeds: [1.8, 4.9, 6],
};
